
define('text!modules/strategy/templates/summaryInfo.html',[],function () { return '<div class="summary-badges-section">\n\t{{#showSummaryBadges}}\n\t<div class="sb-container">\n\t\t<campaigns-strategy-badges id="sb" unresolved></campaigns-strategy-badges>\n\t</div>\n\t{{/showSummaryBadges}}\n</div>';});

